import {Box} from '@mui/material';
import Grid from '@mui/material/Grid';
import AppGridContainer from 'main/core/AppGridContainer';
import AppLoader from 'main/core/AppLoader';
import {isEmpty, notEmpty} from 'main/utility/CommonUtil';
import PropTypes from 'prop-types';
import {createContext, useContext, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {onGetLayoutSpec} from 'redux/actions';
import {REMOVE_LAYOUT_SPEC} from 'shared/constants/ActionTypes';
import {UiWiseWidgetType} from 'shared/constants/UiWiseConst';
import UiWiseWidget from '../UiWiseWidget';
import LayoutTitle from './LayoutTitle';

const LayoutIdContext = createContext(null);
export const useLayoutId = () => useContext(LayoutIdContext);

const UiWiseLayout = ({layoutId}) => {
  const dispatch = useDispatch();

  const layoutSpecs = useSelector(
    ({commonReducer}) => commonReducer.layoutSpecsById[layoutId],
  );

  useEffect(() => {
    if (isEmpty(layoutSpecs)) {
      dispatch(onGetLayoutSpec(layoutId));
    }

    return () => {
      // Clean up the state to avoid memory leaks
      dispatch({type: REMOVE_LAYOUT_SPEC, layoutId: layoutId});
    };
  }, [dispatch, layoutId]);

  const widgets = layoutSpecs?.widgets ?? [];
  const renderableWidgets = widgets.filter(
    (w) => w.widgettype !== UiWiseWidgetType.ALERT,
  );
  const isSingleWidget = renderableWidgets.length === 1;
  const hasSpecs = notEmpty(layoutSpecs) && renderableWidgets.length > 0;

  return (
    <LayoutIdContext.Provider value={layoutId}>
      <Box sx={{position: 'relative'}}>
        <LayoutTitle title={layoutSpecs?.layouttitle} />

        {hasSpecs ? (
          <AppGridContainer>
            {renderableWidgets.map((widget) => (
              <Grid
                item
                key={widget.widgetid}
                xs={12}
                md={widget.md || 12}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <UiWiseWidget
                  widgetSpec={widget}
                  isSingleWidget={isSingleWidget}
                />
              </Grid>
            ))}
          </AppGridContainer>
        ) : (
          /* 2. ONLY the content area shows the loader */
          <Box sx={{display: 'flex', justifyContent: 'center', mt: 10}}>
            <AppLoader />
          </Box>
        )}
      </Box>
    </LayoutIdContext.Provider>
  );
};

export default UiWiseLayout;

UiWiseLayout.propTypes = {
  layoutId: PropTypes.string.isRequired,
};
